import 'core-js/modules/es6.set' // react-dom
import 'core-js/modules/es6.map' // react-dom
import 'core-js/modules/es6.string.starts-with' // redux-form
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from 'react'
import { StyleCoreProvider } from '@prima-afp/prima-ui-design-system/dist/providers'

export const wrapRootElement = ({ element }) => {
  return (
    <StyleCoreProvider assetsUrl={process.env.GATSBY_ASSETS_URL}>
      {element}
    </StyleCoreProvider>
  )
}
